import * as actions from '../actions/legalFormActionTypes';


const initialState = {
  legalFormList: {
    success: false,
    errors: null,
    warnings: null,
    legalForms: [   
      {
        legalFormKey: ".",
        languageData: [
          {
            language: "deu",
            name: "...",
            code: ""
          },
          {
            language: "ita",
            name: "...",
            code: ""
          },
          {
            language: "eng",
            name: "...",
            code: ""
          }
        ] 
      }
    ]  
  }
}


function legalForm(state = initialState, action) {  
  switch (action.type) {
    case actions.LEGAL_FORM_LIST_LOAD:
      return {
        ...state, 
        legalFormList: action.legalFormList
      }    
    default:        
      return state
  } 
}


export default legalForm
